const COLUMNS = [
  {
    title: '浏览分区',
    links: [
      { label: '今日焦点', href: '#focus' },
      { label: '线索追踪', href: '#thread' },
      { label: '动态聚合', href: '#feed' },
      { label: '线索投稿', href: '#submit' },
    ],
  },
  {
    title: '榜单入口',
    links: [
      { label: '实时热度榜', href: '#rank' },
      { label: '热搜榜 Top 10', href: '#rank' },
      { label: '更新榜', href: '#rank' },
      { label: '追踪线聚合', href: '#thread' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '聚合说明', href: '#focus' },
      { label: '投稿规范', href: '#submit' },
      { label: '内容更正', href: '#submit' },
      { label: '回到顶部', href: '#top' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-label text-base font-bold text-background-50">
                51
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">
                黑料51
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-100/70">
              黑料51是一个把黑料动态与黑料线索汇总在一起的资讯聚合入口。旧料翻新、新料追问，都在同一条时间线上，想看后续变化，顺着这条线继续盯就好。
            </p>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3">
              <span className="flex flex-col">
                <span className="font-label text-2xl font-semibold text-accent-500">128</span>
                <span className="mt-0.5 text-xs text-background-100/60">今日更新条数</span>
              </span>
              <span className="flex flex-col">
                <span className="font-label text-2xl font-semibold text-accent-500">37</span>
                <span className="mt-0.5 text-xs text-background-100/60">在追线索</span>
              </span>
              <span className="flex flex-col">
                <span className="font-label text-2xl font-semibold text-accent-500">10</span>
                <span className="mt-0.5 text-xs text-background-100/60">分钟滚更一次</span>
              </span>
            </div>
          </div>

          {COLUMNS.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-background-100/50">
                {column.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="whitespace-nowrap text-sm text-background-100/80 transition-colors hover:text-accent-500"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10">
              <i className="ri-arrow-up-line text-lg text-accent-500" />
            </span>
            <a
              href="#top"
              className="mt-3 block whitespace-nowrap text-sm text-background-100/80 transition-colors hover:text-accent-500"
            >
              回到顶部
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/55">
            © 2026 黑料51 · 资讯聚合展示页面，内容为示例数据
          </p>
          <p className="max-w-xl text-xs leading-relaxed text-background-100/45">
            本站只做公开信息的整理与串线展示，不鼓励任何未经核实的传播；涉及个人隐私的内容请勿投稿。
          </p>
        </div>
      </div>
    </footer>
  );
}